import anime from 'animejs'
import { get } from '@bigyouth/base'
import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'toggle-content',

  ui: {
    'button': '[js-toggle-content-button]',
    'close': '[js-toggle-content-close]',
    'content': '[js-toggle-content-content]',
  },

  events: [
    {
      target: 'button',
      on: 'click',
      handle ({ target }) {
        this.openPanel()
      },
    },
  ],

  componentDidMount () {
    if (this.ui.close != null) {
      this.ui.close.addEventListener('click', () => {
        this.closePanel(this.ui.content)
      })
    }

    if (this.props && this.props.active) {
      this.openPanel()
    }
  },

  openPanel () {
    // if connected accordions
    if (this.props && this.props.connected) {
      const activePanel = get('[js-toggle-content-content].is-visible', this.el.parentNode)
      const activeButton = get('[js-toggle-content-button].is-active')

      if (activeButton && activeButton !== this.ui.button) {
        activeButton.classList.toggle('is-active')
      }

      if (activePanel && activePanel !== this.ui.content) {
        this.closePanel(activePanel)
      }
    }

    this.ui.button.classList.toggle('is-active')
    this.ui.content.classList.toggle('is-visible')

    if (this.ui.content.classList.contains('is-visible')) {
      this.ui.content.style.height = 'auto'
      const height = this.ui.content.offsetHeight
      this.ui.content.style.height = 0

      anime({
        targets: [ this.ui.content ],
        height: height,
        duration: 500,
        easing: [0.6, 0.1, 0.1, 1],
        complete: () => {
          this.ui.content.style.height = 'auto'
        },
      })
    } else {
      anime({
        targets: [ this.ui.content ],
        height: 0,
        duration: 500,
        easing: [0.6, 0.1, 0.1, 1],
      })
    }
  },

  closePanel (panel) {
    panel.classList.toggle('is-visible')

    anime({
      targets: [ panel ],
      height: 0,
      duration: 500,
      easing: [0.6, 0.1, 0.1, 1],
    })

    setTimeout(() => {
      if (this.props && this.props.scrollUp) {
        this.scrollUp()
      }
    }, 300)
  },

  scrollUp () {
    const offset = this.el.parentNode.parentNode.parentNode.offsetTop + this.el.offsetTop - 120

    if (window.scrollY > offset) {
      window.scrollTo({
        top: offset,
        left: 0,
        behavior: 'smooth',
      })
    }
  },
})
